function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { connect } from "react-redux";
import QuickSlideNav from "../components/QuickSlideNav";
import { goToSlide } from "../actions";
import { getSlideIndex, isSlideAvailable } from "../utils/helpers";
import store from "../store";
var mapStateToProps = function(state, _) {
    var slides = state.nodes.filter(function(n) {
        return n.target_type !== "Filter";
    });
    return {
        currentSlideIndex: getSlideIndex(state.currentSlide, state) + 1,
        slides: slides,
        maxSlides: slides.length
    };
};
var mapDispatchToProps = function(dispatch, _) {
    return {
        goTo: function(slide) {
            dispatch(goToSlide({
                id: slide.id
            }));
            return isSlideAvailable(slide, store.getState());
        }
    };
};
var mergeProps = function(stateProps, dispatchProps, ownProps) {
    return _objectSpreadProps(_objectSpread({}, ownProps, stateProps, dispatchProps), {
        goTo: function(index) {
            return dispatchProps.goTo(stateProps.slides[index - 1]);
        }
    });
};
export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(QuickSlideNav);
